import React from "react";
import ReactPlayer from "react-player";

interface ContactPageProps {
  title?: string;
  videoUrl?: string;
}

const Video: React.FC<ContactPageProps> = ({
  title = "Notre Équipe",
  videoUrl = "https://www.youtube.com/watch?v=o8zBbY2cQuQ",
}) => {
  return (
    <div className="relative py-20 px-4 overflow-hidden bg-gradient-to-b from-gray-50 to-white">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary/5 rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>

      <div className="container mx-auto max-w-3xl relative z-10">
        {/* Title Section */}
        <div className="text-center mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-primary mb-4 leading-tight">
            {title}
          </h2>

          {/* Decorative underline */}
          <div className="flex items-center justify-center gap-2 mt-6">
            <div className="h-1 w-20 bg-gradient-to-r from-transparent to-primary rounded-full"></div>
            <div className="h-1 w-12 bg-primary rounded-full"></div>
            <div className="h-1 w-20 bg-gradient-to-l from-transparent to-secondary rounded-full"></div>
          </div>
        </div>

        {/* Video Container */}
        <div className="group relative">
          {/* Card wrapper with modern styling */}
          <div className="relative bg-white rounded-3xl shadow-2xl overflow-hidden transition-all duration-500 hover:shadow-3xl hover:scale-[1.02]">
            {/* Gradient border effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-primary via-secondary to-primary opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl"></div>

            {/* Inner card */}
            <div className="relative bg-white m-1 rounded-3xl overflow-hidden">
              {/* Video wrapper with aspect ratio */}
              <div className="relative aspect-video bg-gray-900">
                <ReactPlayer
                  url={videoUrl}
                  width="100%"
                  height="100%"
                  controls={true}
                  className="absolute top-0 left-0"
                />
              </div>

              {/* Bottom gradient overlay */}
              <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black/10 to-transparent pointer-events-none"></div>
            </div>
          </div>

          {/* Decorative corner elements */}
          <div className="absolute -top-4 -left-4 w-24 h-24 bg-gradient-to-br from-primary/20 to-transparent rounded-full blur-2xl"></div>
          <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-gradient-to-tl from-secondary/20 to-transparent rounded-full blur-2xl"></div>
        </div>
      </div>
    </div>
  );
};

export default Video;
